import { Activity, TopActivity } from '@/repositories';
import { create } from 'zustand';

export type ActivityDetailsDialogPayload = Activity | TopActivity;

interface ActivityDetailsDialogStore {
	isOpen: boolean;
	activity: ActivityDetailsDialogPayload | null;
	showGameCta: boolean;
	openDialog: (payload: { activity: ActivityDetailsDialogPayload; showGameCta?: boolean }) => void;
	closeDialog: () => void;
}

export const useActivityDetailsDialogStore = create<ActivityDetailsDialogStore>((set) => ({
	isOpen: false,
	activity: null,
	showGameCta: true,
	openDialog: ({ activity, showGameCta = true }) =>
		set({
			activity,
			showGameCta,
			isOpen: true,
		}),
	closeDialog: () =>
		set({
			activity: null,
			showGameCta: true,
			isOpen: false,
		}),
}));
